var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "configForm",
          attrs: {
            model: _vm.configForm,
            rules: _vm.configFormRules,
            "label-position": "right",
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "参数名称", prop: "paramName" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", disabled: _vm.operationType == "view" },
                model: {
                  value: _vm.configForm.paramName,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "paramName", $$v)
                  },
                  expression: "configForm.paramName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "参数描述", prop: "paramDesc" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", disabled: _vm.operationType == "view" },
                model: {
                  value: _vm.configForm.paramDesc,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "paramDesc", $$v)
                  },
                  expression: "configForm.paramDesc",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据类型", prop: "dataType" } },
            [
              _c("ic-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  table: "TT_PROC",
                  field: "DATA_TYPE",
                  clearable: "",
                  disabled: _vm.operationType == "view",
                },
                model: {
                  value: _vm.configForm.dataType,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "dataType", $$v)
                  },
                  expression: "configForm.dataType",
                },
              }),
            ],
            1
          ),
          _vm.configForm.dataType == "SELECTOR"
            ? _c(
                "el-form-item",
                { attrs: { label: "选择器类型", prop: "selectorType" } },
                [
                  _c("ic-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      table: "TT_PROC",
                      field: "SELECTOR_TYPE",
                      clearable: "",
                      disabled: _vm.operationType == "view",
                    },
                    model: {
                      value: _vm.configForm.selectorType,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "selectorType", $$v)
                      },
                      expression: "configForm.selectorType",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.configForm.dataType == "DICT"
            ? _c(
                "el-form-item",
                { attrs: { label: "字典", prop: "selectorType" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.configForm.selectorType,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "selectorType", $$v)
                      },
                      expression: "configForm.selectorType",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "单位", prop: "uom" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", disabled: _vm.operationType == "view" },
                model: {
                  value: _vm.configForm.uom,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "uom", $$v)
                  },
                  expression: "configForm.uom",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "统计类型", prop: "statsType" } },
            [
              _c("ic-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  table: "TT_PROC",
                  field: "STATISTIC_TYPE",
                  disabled: _vm.operationType == "view",
                },
                model: {
                  value: _vm.configForm.statsType,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "statsType", $$v)
                  },
                  expression: "configForm.statsType",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商是否可见", prop: "supplierViewable" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-text": "是",
                  "inactive-text": "否",
                  disabled: _vm.operationType == "view",
                },
                model: {
                  value: _vm.configForm.supplierViewable,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "supplierViewable", $$v)
                  },
                  expression: "configForm.supplierViewable",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否换行显示", prop: "lineBreak" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-text": "是",
                  "inactive-text": "否",
                  disabled: _vm.operationType == "view",
                },
                model: {
                  value: _vm.configForm.lineBreak,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "lineBreak", $$v)
                  },
                  expression: "configForm.lineBreak",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "所属分组", prop: "category" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", disabled: _vm.operationType == "view" },
                model: {
                  value: _vm.configForm.category,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "category", $$v)
                  },
                  expression: "configForm.category",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公式定义", prop: "statsExpr" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入公式定义",
                  maxlength: "4000",
                  "show-word-limit": "",
                  disabled: _vm.operationType == "view",
                },
                model: {
                  value: _vm.configForm.statsExpr,
                  callback: function ($$v) {
                    _vm.$set(_vm.configForm, "statsExpr", $$v)
                  },
                  expression: "configForm.statsExpr",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center", align: "middle" } },
            [
              _vm.operationType != "view"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onCancel },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }